import { AsyncPipe } from '@angular/common';
import { Component, ElementRef, inject, viewChild } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

import { SearchLocationService } from '../../services/search-location.service';
import { LocationPickerComponent } from '../location-picker/location-picker.component';

/** The part of Bootstrap's `Dropdown` plugin this component uses; the bundle registers it on `window`. */
interface BootstrapDropdownPlugin {
  getOrCreateInstance(element: Element): { hide(): void };
}

/**
 * #172: the location chip in the header — the chosen place with a pin icon, or „Standort
 * wählen" while there is none — and the „Standort ändern" entry: it opens a dropdown with the
 * picker. The dummy that stood here until #178 („Berlin, Musterstraße 12") is what this replaces.
 *
 * The dropdown is Bootstrap's own (`data-bs-toggle`), like the account menu, with
 * `data-bs-auto-close="outside"` so typing in the picker's fields does not close it; a
 * successful pick closes it through the plugin, guarded because the plugin is absent in a spec.
 */
@Component({
  imports: [FontAwesomeModule, AsyncPipe, LocationPickerComponent],
  selector: 'app-location-indicator',
  templateUrl: './location-indicator.component.html',
  styleUrls: ['./location-indicator.component.css'],
})
export class LocationIndicatorComponent {
  readonly locationService = inject(SearchLocationService);

  readonly faMapMarkerAlt = faMapMarkerAlt;
  readonly placeholder = $localize`:@@location.choose:Standort wählen`;

  private readonly toggle = viewChild<ElementRef<HTMLElement>>('toggle');

  closeMenu(): void {
    const element = this.toggle()?.nativeElement;
    const plugin = (globalThis as { bootstrap?: { Dropdown?: BootstrapDropdownPlugin } }).bootstrap?.Dropdown;
    if (element && plugin) {
      plugin.getOrCreateInstance(element).hide();
    }
  }
}
